import { Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { MustMatch } from "./MustMatch";
import { Router } from "@angular/router";
import { HastaService } from "../services/hasta.service";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogBoxComponent } from "../dialog-box/dialog-box.component";
import { DogrulamaKod } from "../models/dogrulama-kod";
import { DogrolamaGiden } from "../models/dogrolama-giden";
import { JwtHelperService } from "@auth0/angular-jwt";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "app-kimlik-bilgisi",
  templateUrl: "./kimlik-bilgisi.component.html",
  styleUrls: ["./kimlik-bilgisi.component.css"],
})
export class KimlikBilgisiComponent implements OnInit {
  registerForm: FormGroup;
  submitted = false;
  cinsiyetList: any = ["Kadın", "Erkek"];

  dogrulamaKod: DogrulamaKod[];
  dogrulamaResim: string;
  dogrulamaGiden: DogrolamaGiden[];

  snc: any;

  jwtHelper: JwtHelperService = new JwtHelperService();

  constructor(
    private formBuilder: FormBuilder,
    private hasta: HastaService,
    private router: Router,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.dogrulamaResim = "";
    this.registerForm = this.formBuilder.group(
      {
        tcKimlik: [
          "",
          [
            Validators.required,
            Validators.minLength(11),
            Validators.maxLength(11),
          ],
        ],
        dogumTarihi: ["", Validators.required],
        babaAdi: ["", Validators.required],
        cinsiyet: ["", Validators.required],
        hastaAdi: ["", Validators.required],
        soyadi: ["", Validators.required],
        cepTelefonu: ["", Validators.required],
        email: ["", [Validators.required, Validators.email]],
        guidKodu: ["", Validators.required],
        dogrulamaKodu: ["", Validators.required],
      },
      {
        //    validator: MustMatch("password", "confirmPassword")
      }
    );
    this.resimYukle();
    this.dogrulamaGiden = [];
  }

  get f() {
    return this.registerForm.controls;
  }

  onReset() {
    this.submitted = false;
    this.registerForm.reset();
  }

  onSubmit() {
    this.registerForm.patchValue({ guidKodu: this.dogrulamaKod["guidKodu"] });
    this.submitted = true;
    if (this.registerForm.invalid) {
      return;
    }
    /*
    alert(
          "SUCCESS!! :-)\n\n" + JSON.stringify(this.registerForm.value, null, 4)
        );
*/
    this.tckDogrula();
  }

  resimDogrula() {
    this.dogrulamaGiden["GuidKodu"] = this.dogrulamaKod["guidKodu"];
    this.dogrulamaGiden["DogrulamaKodu"] = this.registerForm.get(
      "dogrulamaKodu"
    ).value;

    this.hasta.dogrula(this.dogrulamaGiden).subscribe((response) => {
    });
  }

  resimYukle() {
    this.hasta.dogrulamaKodu().subscribe((response) => {
      this.dogrulamaKod = response;
      this.dogrulamaResim = response["imageStr"];
    });
  }

  resimYenile() {
    this.registerForm.get("dogrulamaKodu").reset();
    this.resimYukle();
  }

  tckDogrula() {
    this.hasta
      .getTCKDogrulama(this.registerForm.value)
      .subscribe((response) => {
        if (response) this.formDataGonder();
        else
          this.openDialog(
            "TC. Kimlik No Uyarı!",
            "Girilen TC Kimlik bilgisi hatalı lütfen kontol ediniz!",
            "Tamam",
            null
          );
      });
  }

  formDataGonder() {

    this.hasta
      .loadHastaBilgisi(this.registerForm.value)
      .subscribe((response) => {
        if (!this.jwtHelper.isTokenExpired(response["sonucToken"])) {
          localStorage.setItem("TurcaSoft", response["sonucToken"]);
          this.router.navigateByUrl("randevu-ver");
        } else {
          this.openDialog("Uyarı!", response["sonucAciklama"], "Tamam", null);
          //this.onReset();
        }
      });
  }

  hastaKimlikBilgisi() {
    if (this.registerForm.get("tcKimlik").value) {
      this.hasta
        .getHastaBilgisi(this.registerForm.get("tcKimlik").value)
        .subscribe((response) => {
          this.registerForm.patchValue(response);
        });
    } else
      this.openDialog(
        "TC. Kimlik No Uyarı!!",
        "Kayıtlı hasta sorgolamak için öncelikle 11 haneli TC. kimlik numarasını giriniz!",
        "Tamam",
        null
      );
  }

  openDialog(
    _baslik: string,
    _mesaj: string,
    _bntOk: string,
    _btnIptal: string
  ): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "40%";

    let dialogRef = this.dialog.open(DialogBoxComponent, {
      disableClose: true,
      autoFocus: true,
      width: "45%",

      data: {
        baslik: _baslik,
        mesaj: _mesaj,
        bntOk: _bntOk,
        btnIptal: _btnIptal,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
    });

    const dialogSubmitSubscription = dialogRef.componentInstance.submitClicked.subscribe(
      (result) => {
        ///  dialogSubmitSubscription.unsubscribe();
      }
    );
  }
}
